export const FAQS_LINK = 'https://paymentshield.helpshift.com/hc/en/';
export const TWITTER_LINK = 'http://twitter.com/paymentshield';
export const COOKIES_LINK = 'https://www.paymentshield.co.uk/cookie-policy';
export const PRIVACY_POLICY_LINK = 'https://www.paymentshield.co.uk/fair-processing-notice';
